/**
 * Pure helpers shared by the backoffice nav's tool picker and the "All tools" hub page, so both
 * agree on what "matches a search" and "is the current tool" mean.
 */

/** Tools whose path is a prefix of other routes and so only count as current on an exact match
 * (`/backoffice/dashboard` must not light up on `/backoffice/dashboard/user-agents`). */
const EXACT_MATCH_ONLY_PATHS = new Set(['/backoffice/dashboard', '/backoffice/architecture']);

export function isBackofficeToolActive(toolPath: string, urlPathname: string, localePrefix: string): boolean {
  const href = `${localePrefix}${toolPath}`;
  if (urlPathname === href) return true;
  return !EXACT_MATCH_ONLY_PATHS.has(toolPath) && urlPathname.startsWith(`${href}/`);
}

/** Lowercase and strip diacritics so "tyokalu" finds "työkalu" and "atgard" finds "åtgärd". */
export function normalizeSearchText(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();
}

/**
 * Every whitespace-separated word in `query` must appear somewhere in `haystack` (any order), so
 * "logs pipe" still finds "Pipeline logs". An empty query matches everything.
 */
export function matchesToolQuery(haystack: string, query: string): boolean {
  const words = normalizeSearchText(query).split(/\s+/).filter(Boolean);
  if (words.length === 0) return true;
  const target = normalizeSearchText(haystack);
  return words.every((word) => target.includes(word));
}
